import { splitProps, createRenderEffect, onCleanup } from 'solid-js';
import { isServer, spread } from 'solid-js/web';

// src/index.ts
var OMITTED_PROPS = ["src"];
function createScriptLoader(props) {
  if (isServer) {
    return void 0;
  }
  const script = document.createElement("script");
  const eventKeys = Object.keys(props).filter((p) => p.startsWith("on"));
  const [local, events, scriptProps] = splitProps(
    props,
    OMITTED_PROPS,
    eventKeys
  );
  setTimeout(() => spread(script, scriptProps, false, true));
  createRenderEffect(() => {
    Object.entries(events).forEach(
      ([name, handler]) => script.addEventListener(
        /^on:?(.*)/.test(name) ? name.startsWith("on:") ? RegExp.$1 : RegExp.$1.toLowerCase() : name,
        (ev) => {
          Object.defineProperties(ev, {
            target: { value: script, enumerable: true },
            currentTarget: { value: script, enumerable: true }
          });
          Array.isArray(handler) ? handler[0](handler[1], ev) : typeof handler === "function" && handler?.call(null, Object.assign(ev));
        }
      )
    );
    const src = typeof local.src === "string" ? local.src : local.src();
    const prop = /^(https?:|\w[\.\w-_%]+|)\//.test(src) ? "src" : "textContent";
    if (script[prop] !== src) {
      script[prop] = src;
      document.head.appendChild(script);
    }
  });
  onCleanup(() => document.head.contains(script) && document.head.removeChild(script));
  return script;
}

export { createScriptLoader };
